import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from "../FindModuleById";
import { useFormik, FormikProvider } from "formik";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";

// Custom Option component with checkbox
// eslint-disable-next-line react/prop-types
const Option = ({ isSelected, label, ...props }) => {
  return (
    <div>
      <components.Option {...props} isSelected={isSelected} label={label}>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => null}
          style={{ marginRight: "8px" }}
        />{" "}
        <label>{label}</label>
      </components.Option>
    </div>
  );
};


const ProductionFeedAdd = () => {
  const [ordersLists, setOrdersLists] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime());
  const [permission, setPermission] = useState({});

  let season_id = localStorage.getItem("season_id");

  // Helper: Get Current DateTime for datetime-local input
  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = `${now.getMonth() + 1}`.padStart(2, "0");
    const day = `${now.getDate()}`.padStart(2, "0");
    const hours = `${now.getHours()}`.padStart(2, "0");
    const minutes = `${now.getMinutes()}`.padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  function calculateShift(dateValue) {
    const dateObj = new Date(dateValue);
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      console.error("Invalid date:", dateValue);
      return { shift: "", shiftDate: "" };
    }

    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const timeInMinutes = hours * 60 + minutes;

    const shift1Start = 8 * 60 + 30;  // 08:30
    const shift1End = 19 * 60;        // 19:00
    const shift2Start = 20 * 60 + 30; // 20:30
    const shift2End = 7 * 60;         // 07:00 

    let shift = "";
    
    // Get the date in YYYY-MM-DD format
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    let shiftDate = `${year}-${month}-${day}`;

    if (timeInMinutes >= shift1Start && timeInMinutes <= shift1End) {
      shift = 1;
    } else if (timeInMinutes >= shift2Start || timeInMinutes <= shift2End) {
      shift = 2;
      
      // If time is between 00:00 and 07:00, subtract 1 day
      if (timeInMinutes <= shift2End) {
        const prevDate = new Date(dateObj);
        prevDate.setDate(prevDate.getDate() - 1);
        const prevYear = prevDate.getFullYear();
        const prevMonth = String(prevDate.getMonth() + 1).padStart(2, '0');
        const prevDay = String(prevDate.getDate()).padStart(2, '0');
        shiftDate = `${prevYear}-${prevMonth}-${prevDay}`;
      }
    }

    console.log("Input:", dateValue, "| Time:", `${hours}:${minutes}`, "| Shift:", shift, "| Date:", shiftDate);
    
    return { shift, shiftDate };
  }

  // Formik setup
  const formik = useFormik({
    initialValues: {
      season_id: season_id,
      date_time: currentDateTime,
      shift_date: "",
      shift: "",
      palletesation: [],
    },
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/production-feeds/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors["error"];
          $("#form-submit").text("Add Production Feed");
          if (response.data.code === 200) {
            toast.success(response.data.message);
            setTimeout(() => {
              window.location.href = "/production-feeds-add";
            }, 1000);
          } else if (response.data.code === 422) {
            setSubmitting(false);
            setBackendErrors(response.data.error);
          } else {
            setSubmitting(false);
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  // Menu toggle
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  // Fetch permissions and data
  useEffect(() => {
    setPermission(FindModuleById(71));

    let para = { season_id: season_id };
    axios
      .post("/raw-materials-palletesation/listing-remaining-palletesation", para, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let orders = response.data.data.palletisation;
          let productslisting = orders.map((shipp, index) => ({
            value: shipp.raw_id,
            label: `${shipp.barcode} (${shipp.lot_number})`,
            key: `farmer-${index}`,
          }));
          setOrdersLists(productslisting);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Set initial shift based on current time
  useEffect(() => {
    const { shift, shiftDate } = calculateShift(currentDateTime);
    formik.setFieldValue("shift", shift);
    formik.setFieldValue("shift_date", shiftDate);
  }, []);

  // Input change cleanup
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  // Updated Select handler for multi-select with checkboxes
  const handleSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    formik.setFieldValue("palletesation", values);
    customHandleInput({ target: { name: "palletesation", value: values } });
  };

  // DateTime Change
  const handleDateTimeChange = (e) => {
    const value = e.target.value;
    setCurrentDateTime(value);
    formik.setFieldValue("date_time", value);

    const { shift, shiftDate } = calculateShift(value);
    formik.setFieldValue("shift", shift);
    formik.setFieldValue("shift_date", shiftDate);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={toggleMobileMenu} />
        <Sidebar />
        <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Feed</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-feeds">Production Feed</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Production Feed</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.add == 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Production Feed Info</h4>
                      <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Palletesation</label>
                                <input
                                  type="hidden"
                                  name="shift_date"
                                  value={formik.values.shift_date || ""}
                                />
                                <Select
                                  className="w-100"
                                  value={ordersLists.filter((option) =>
                                    formik.values.palletesation.includes(option.value)
                                  )}
                                  name="palletesation"
                                  onChange={handleSelectChange}
                                  onBlur={formik.handleBlur}
                                  options={ordersLists}
                                  placeholder="Select Palletesation"
                                  isMulti={true}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  components={{
                                    Option
                                  }}
                                />
                                <small>
                                  {backendErrors.palletesation && (
                                    <span className="form-error mt-1">
                                      {backendErrors.palletesation}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Date Time</label>
                                <input
                                  type="datetime-local"
                                  name="date_time"
                                  value={formik.values.date_time}
                                  className="form-control"
                                  onChange={handleDateTimeChange}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.date_time && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date_time}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Shift (1 or 2)</label>
                                <input
                                  type="text"
                                  name="shift"
                                  value={formik.values.shift}
                                  className="form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }} 
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.shift && (
                                    <span className="form-error mt-1">
                                      {backendErrors.shift}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                          </div>

                          <div className="text-end mt-4">
                            <button
                              type="submit"
                              id="form-submit"
                              className="btn btn-primary"
                              disabled={formik.isSubmitting}
                            >
                              Add Production Feed
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductionFeedAdd;